import { render, staticRenderFns } from "./v-pill-shape-form-special-shape.vue?vue&type=template&id=599d970c&scoped=true"
import script from "./v-pill-shape-form-special-shape.vue?vue&type=script&lang=js"
export * from "./v-pill-shape-form-special-shape.vue?vue&type=script&lang=js"
import style0 from "./v-pill-shape-form-special-shape.vue?vue&type=style&index=0&id=599d970c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599d970c",
  null
  
)

export default component.exports